
import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
// reactstrap components
import {
  Button, InputGroup, InputGroupText, Spinner,
  Card,Badge, Modal, ModalBody, ModalHeader,
  CardHeader, 
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import {fieldvalidator, filenamevalid, alphanum, alpha, numtests, numdtest, alphaspace,
  floattest, numtest, email} from '../../../helpers/validate'
import {customStyles} from '../../../helpers/mycomps'
  
import TenantList from './TenantList'
import { useSelector , useDispatch} from 'react-redux'
import dlogo from "../../images/Logo.jpeg"
import dp from "../../images/dp.jpg"
import { useHistory} from 'react-router-dom'
//import Spin from '../../../assets/img/Spinner.gif'
import { Rating } from 'react-simple-star-rating'


function Tenant(props) {
  const history = useHistory()
  const [showProcessing , setShowProcessing] = useState(false)
  const [showLogoProcessing , setShowLogoProcessing] = useState(false)
  const [fulltextsearch, setFulltextsearch] = useState("")
  const [tenantslist, setTenantslist] = useState([])
  const [showlist, setShowlist] = useState(true)
  const hiddenFileInput = useRef(null);
  const [tenant , setTenant] = useState({
    tid : "",
    tuid : "",
    managerid : "",
    enqEmail : "",
    mngName : "",
    cellNumber : "",
    cellNumberc : "",
    landLine : "",
    cellIsVerified : false,
    waNumber  :"",
    liProfile : "",
    fbProfile : "",
    insProfile : "",
    stAddr  :"",
    addressIsVerified : false,
    postal : "",
    aboutWords : "",
    aboutWordsar : "",
    timage : "",
    rating : 0
   })

  const [updateMode, setUpdateMode] = useState(false)
  const [tname, setTname] = useState({en : "", fr : "", ar : ""})
  const [area, setArea] = useState({areaCode : "", en : "", fr : "", ar : ""})
  const [city, setCity] = useState({cityCode : "", en : "", fr : "", ar : ""})
  const [allowedCategories, setAllowedCategories] = useState({cars : false, yacht : false, machines : false})
  const [allowed, setAllowed] = useState({listing : 0, premium : 0, featured : 0})
  const [newPassword, setNewPassword] = useState("")
  const [editP, setEditP] = useState({listing : false, premium : false, featured : false})
  

  const [skippy, setSkippy] = useState(1)
  const [limit, setLimit] = useState(10)
  const [total, setTotal] = useState(500)
  const [pageNumber, setPageNumber] = useState(1) 
  const [showpwc, setShowpwc] = useState(false)
 
  const [opass, setOpass] = React.useState("");
  const [cpass, setCpass] = React.useState("");


  const storarea  = useSelector(state => state.areaStore.areaData).map(x => {
   
    return {
      label :x.cityName.en  , value : x.cityCode, 
      labelfr : x.cityName.fr, labelar : x.cityName.ar,
      areas : x.area
    }
  })

  const [arealist, setArealist] = useState([])

  const [bank , setBank] = useState({
    bankName : "",
    swiftCode : "",
    routingCode : "",
    iban : "",
    account : ""
  })

  const [{alt, src}, setImg] = useState({
    src: dp,
    alt: ''
  });
  const [filenames, setFilenames] = useState()
  
const nextpage = () => {
    let newn = pageNumber + 1
    if(newn >= Math.floor(total/limit)){
        newn = pageNumber
    }else{
        setPageNumber(pageNumber + 1)
    }
  
    searchpagee(newn)
}
const previouspage = () => {
    let newn = pageNumber - 1
    if(newn <= 0){
        newn = pageNumber
    }else{
        setPageNumber(pageNumber - 1)
    }

    searchpagee(newn)
}

  const clearvalues = () => {
    setTenant({
      tid : "",
      tuid : "",
      managerid : "",
      enqEmail : "",
      mngName : "",
      cellNumber : "",
      cellNumberc : "",
      landLine : "",
      cellIsVerified : false,
      waNumber  :"",
      liProfile : "",
      fbProfile : "",
      insProfile : "",
      stAddr  :"",
      addressIsVerified : false,
      postal : "",
      aboutWords : "",
      aboutWordsar : "",
      timage : "",
      rating : 0
     }) ;
     setTname({en : "", fr : "", ar : ""})
     setArea({aid : "", en : "", fr : "", ar : ""})
     setCity({cid : "", en : "", fr : "", ar : ""})
     setAllowedCategories({cars : false, yacht : false, machines : false})
     setNewPassword("")
     setBank({
      bankName : "",
      swiftCode : "",
      routingCode : "",
      iban : "",
      account : ""
    })
    setAllowed({listing : 0, premium : 0, featured : 0})
    setImg({
      src : dp,
      alt : ""
    })
  }

  const submitCreate = () => {
    if(fieldvalidator(tname.en, tenant.managerid, tenant.cellNumberc , tenant.cellNumber, tenant.mngName )){
      props.swal("Tenant Required Fields are EMPTY!")
    }else{
     
      setShowProcessing(true)
      let formData = new FormData(); 
      formData.append("tenantLogo" , filenames)
      formData.append("tname", JSON.stringify(tname) );
      formData.append("tenant", JSON.stringify(tenant) );
      formData.append("bank", JSON.stringify(bank) );
      formData.append("allowed", JSON.stringify(allowed) );
      formData.append("allowedCategories" , JSON.stringify(allowedCategories))
      formData.append("city", JSON.stringify(city) );
      formData.append("area", JSON.stringify(area) );
      props.API({
        method: "post",
        url : `tenant/tenant`,
        data: formData,
        headers : {"arixauth" : localStorage.getItem("arixauth")}
        }).then((res) => {
          props.swal(res.data.message)
          setShowProcessing(false)
          searchpagee(1)
        }).catch(function (error) {
          setShowProcessing(false)
        //  console.log(error.response)
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }else{
          props.swal(error.response.data.message)
        }
         
           console.log("error")
    }) 
    }
    return
     // inputConfirmAlert("Are you sure")
    

      //props.swal(msg)
  }

  const submitUpdate = () => {
    if(fieldvalidator(tname.en, tenant.managerid, tenant.cellNumberc , tenant.cellNumber, tenant.mngName )){
      props.swal("Tenant Required Fields are EMPTY!")
    }else{
    setShowProcessing(true)
    let formData = new FormData(); 
    formData.append("tenantLogo" , filenames)
    formData.append("tname", JSON.stringify(tname) );
    formData.append("tenant", JSON.stringify(tenant) );
    formData.append("bank", JSON.stringify(bank) );
    formData.append("allowed", JSON.stringify(allowed) );
    formData.append("allowedCategories" , JSON.stringify(allowedCategories))
    formData.append("city", JSON.stringify(city) );
    formData.append("area", JSON.stringify(area) );
    props.API({
      method: "post",
      url : `tenant/utenant`,
      data: formData,
      headers : {"arixauth" : localStorage.getItem("arixauth")}
      }).then((res) => {
      props.swal(res.data.message)
        setShowProcessing(false)
        searchpagee(1)
        window.location.reload(false)
      }).catch(function (error) {
        
        setShowProcessing(false)
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }
  }) 
}
    //props.swal(msg)
}
 
  const cinputConfirmAlert = (xcc) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure that you want to update Tenant Profile?",
      icon: "warning",
      dangerMode: true,
    })
    .then(willDelete => {
      if (willDelete) {
        setShowlist(!showlist); xcc === "u" ? submitUpdate() : submitCreate()
      }
    });
    
  };

  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  const handleImg = (e) => {
    
    if(e.target.files[0]) {
            
        if(filenamevalid(e.target.files[0])){
          setFilenames(e.target.files[0])
          setImg({
            src: URL.createObjectURL(e.target.files[0]),
            alt: e.target.files[0].name
        });
        }else{
          props.swal("Invalid Filename")
        }
        
    
    }   
}

  const searchfull = (e) => {
    let url = `tenant/stenant/${e}`
    
    setShowProcessing(true)
    props.API.get(url, {headers : {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
        
          let data = res.data.map((prop, key) => {
            return {
            id: key ,
            tuid: prop.tuid ,
            nameEN: prop.tname.en ,
            nameFR: prop.tname.fr ,
            nameAR: prop.tname.ar ,
            managerid : prop.managerid,
            cellNumberc : prop.cellNumberc,
            actions: (
                // we've added some custom button actions
                <div className="actions-right">
                  {
                    prop.typeIs === "Admin" ? <i className="fa fa-users" aria-hidden="true"></i> :
                    <>
                    <Button
                    onClick={() => {
                      let obj = data.find((o) => o.id === key);
                        //  console.log(obj.managerid)
                          tenanthash(obj.managerid)
                    }}
                    color="info"
                    size="sm"
                    className="btn-icon btn-link edit"
                  >
                    <i className="fa fa-key" />
                  </Button>{" "}                
                 
                 
                  <Button
                     onClick={() => {
                      let obj = data.find((o) => o.id === key);
                        //  console.log(obj.managerid)
                          tenantde(obj.managerid)
                    }}
                    color="danger"
                    size="sm"
                    className="btn-icon btn-link remove"
                  >
                   {prop.disabledRef === "" ?  <i className="fa fa-lock" aria-hidden="true"></i> :  <i className="fa fa-unlock" aria-hidden="true"></i>} 
    
                  </Button>{" "}
                  <Button
                    onClick={() => {
                      let obj = data.find((o) => o.id === key);
                          setImg({
                            src : "",
                            alt : ""
                          })
                            ftenant(obj.managerid)
                            flogo(obj.tuid)
                        }}
                    color="warning"
                    size="sm"
                    className="btn-icon btn-link edit"
                  >
                    <i className="fa fa-edit" />
                  </Button>{" "}
                  <Button
                    onClick={() => {
                      let obj = data.find((o) => o.id === key);
                          setImg({
                            src : "",
                            alt : ""
                          })
                        //    ftenant(obj.managerid)
                        //    flogo(obj.tuid)
                          
                            history.push(`/admin/lapprove/${obj.tuid}`)
                        }}
                    color="warning"
                    size="sm"
                    className="btn-icon btn-link edit"
                  >
                    <i className="fa fa-list" />
                  </Button>{" "}
                  </>
                  }
                   
                </div>
              ),
            }
       })
          setTenantslist(data)
       setShowProcessing(false)
      }).catch(function (error) {
        setShowProcessing(false)
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }
       
           console.log(error)
      }) 

  }

  const searchpagee = (pn) => {
    let url = `tenant/fetchtenants/${skippy * pn}/${limit}`
 
    setShowProcessing(true)
    props.API.get(url, {headers : {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
        setTotal(res.data.total)
          let data = res.data.data.map((prop, key) => {
            return {
            id: key ,
            tuid: prop.tuid ,
            nameEN: prop.tname.en ,
            nameFR: prop.tname.fr ,
            nameAR: prop.tname.ar ,
            managerid : prop.managerid,
            cellNumberc : prop.cellNumberc,
            actions: (
                // we've added some custom button actions
                <div className="actions-right">
                  {
                    prop.typeIs === "Admin" ? <i className="fa fa-users" aria-hidden="true"></i> :
                    <>
                    <Button
                    onClick={() => {
                      let obj = data.find((o) => o.id === key);
                        //  console.log(obj.managerid)
                          tenanthash(obj.managerid)
                    }}
                    color="info"
                    size="sm"
                    className="btn-icon btn-link edit"
                  >
                    <i className="fa fa-key" />
                  </Button>{" "}                
                 
                 
                  <Button
                     onClick={() => {
                      let obj = data.find((o) => o.id === key);
                        //  console.log(obj.managerid)
                          tenantde(obj.managerid)
                    }}
                    color="danger"
                    size="sm"
                    className="btn-icon btn-link remove"
                  >
                   {prop.disabledRef === "" ?  <i className="fa fa-lock" aria-hidden="true"></i> :  <i className="fa fa-unlock" aria-hidden="true"></i>} 
    
                  </Button>{" "}
                  <Button
                    onClick={() => {
                      let obj = data.find((o) => o.id === key);
                          setImg({
                            src : "",
                            alt : ""
                          })
                            ftenant(obj.managerid)
                            flogo(obj.tuid)
                        }}
                    color="warning"
                    size="sm"
                    className="btn-icon btn-link edit"
                  >
                    <i className="fa fa-edit" />
                  </Button>{" "}
                  <Button
                    onClick={() => {
                      let obj = data.find((o) => o.id === key);
                          setImg({
                            src : "",
                            alt : ""
                          })
                        //    ftenant(obj.managerid)
                        //    flogo(obj.tuid)
                          
                            history.push(`/admin/lapprove/${obj.tuid}`)
                        }}
                    color="warning"
                    size="sm"
                    className="btn-icon btn-link edit"
                  >
                    <i className="fa fa-list" />
                  </Button>{" "}
                  </>
                  }
                   
                </div>
              ),
            }
       })
          setTenantslist(data)
       setShowProcessing(false)
      }).catch(function (error) {
        setShowProcessing(false)
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }
           console.log(error)
      }) 

  } 

  useEffect(() => {
    searchpagee(1)
},[limit, pageNumber])


// Reset Password here
  const tenanthash = (tenantid) => {
      setShowProcessing(true)
    props.API.post(`tenant/tenanthash`, {managerid : tenantid},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
        props.swal(res.data.message)
        setShowProcessing(false)
     
      }).catch(function (error) {
        setShowProcessing(false)
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }else{
          props.swal("Error Resetting tenant Password")
        }
       
         
      }) 
  }

//Disable / Enable here 
  const tenantde = (tenantid) => {
    setShowProcessing(true)
    props.API.post(`tenant/tenantde`, {managerid : tenantid},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
        props.swal(res.data.message)
        setShowProcessing(false)
                    
      }).catch(function (error) {
        setShowProcessing(false)
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }else{
          props.swal("Error configuring tenant")
        }
        console.log(error)
        
      }) 
    }

// fetch tenant for update 
  const ftenant = (managerid) => {
    setShowProcessing(true)
    props.API.get(`tenant/ftenant/${managerid}`, { headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
      //  props.swal(res.data.message)
        setShowProcessing(false)
                           setUpdateMode(true)
                          setShowlist(false)
                        
                          setTname(res.data.data.tname)
                          setAllowed(res.data.data.allowed)
                          setArea(res.data.data.areas)
                          setCity(res.data.data.city)
                          setBank(res.data.data.bank)
                          setAllowedCategories({cars : res.data.data.cat_car_allowed , yacht : res.data.data.cat_yacht_allowed , machines : res.data.data.cat_machines_allowed})
                          setTenant({...res.data.data})
      }).catch(function (error) {
        setShowProcessing(false)
        console.log(error)
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }else{
          props.swal("Error fetching tenant by ID")
        }
        
      }) 
  }


  const flogo = (tuid) => {
    
    setShowLogoProcessing(true)
    props.API.get(`tenant/tlogo/${tuid}`,{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
      //  props.swal(res.data.message)
        setShowLogoProcessing(false)
        setImg({
          src:`data:image/${res.data.ftype};base64,${res.data.bdata}`
          ,alt : "file"})               
      }).catch(function (error) {
        setShowLogoProcessing(false)
        console.log(error)
        setImg({
          src : dp,
          alt : ""
        })
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }
        
       // props.swal("Error fetching tenant by ID")
      
      }) 
  }


// Change Password
const cangep = (f) => {
  f.preventDefault()
  setShowProcessing(true)
  props.API.post(`ten/rnmcp`, {guid : tenant.managerid, opass : opass, cpass : cpass},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
     props.swal(res.data.message)
      setShowProcessing(false)
      setShowpwc(false)
    }).catch(function (error) {
      setShowProcessing(false)
       console.log(error)
       if(error.response.status === 401){
        props.swal("Unauthorized, please login again.").then(t => {
            props.history.push(`/auth/login`)
        })   
      }else{
        props.swal("Error Resetting tenant Password")
      }
      
    })      
}

const pwchange = () => {
  return (
    <Modal isOpen={showpwc}>
      <ModalHeader  toggle={p => setShowpwc(false)}></ModalHeader>
      <ModalBody>
        <Row>
          <Col></Col>
          <Col md="4">Old</Col>
          <Col md="6"><Input type="text" onChange={d => setOpass(d.target.value)} maxLength={24} /></Col>
          <Col></Col>
        </Row>
        <Row style={{marginTop : 10}}>
          <Col></Col>
          <Col md="4">New</Col>
          <Col md="6"><Input type="text" maxLength={24} onChange={d => setCpass(d.target.value)}/></Col>
          <Col></Col>
        </Row>
        <hr />
        <Row>
          <Col><center><Button size="sm" color={"warning"} onClick={f => cangep(f)}>Update</Button></center></Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}


  return (
    <>
     {pwchange()}  
    <input
         ref={hiddenFileInput}
         type="file" 
         accept=".png, .jpg, .jpeg" 
         id="photo" 
         className="visually-hidden"
         onChange={e=> handleImg(e)}
         hidden/>

    
      {showlist ? <div className="content">
        {showProcessing && props.Spin}
                <Row>
                    <Col>
                    <Card >
                      <CardHeader>
                      <h6 className="title">Tenant List  <i className="fa fa-file-text-o" aria-hidden="true" onClick={x => {setShowlist(!showlist);setUpdateMode(false); clearvalues()}} style={{float : "right", cursor : "pointer", paddingLeft : 15, paddingRight : 15}} ></i> </h6>
                      </CardHeader>
                      <CardBody>
                        <Row>
                          <Col xl="8" md="8" sm="12">
                          <FormGroup>
                               
                                <InputGroup>
                                    <Input
                                        maxLength={150}
                                        placeholder="EN Name / ID / manager id / cell number"
                                        type="text"
                                        value = {fulltextsearch}
                                        onChange={x => setFulltextsearch(x.target.value)}
                                        onKeyDown={e => {
                                          if (e.key === 'Enter') {
                                            searchfull(fulltextsearch)
                                          }
                                        }}
                                    />
                                    <InputGroupText>
                                    <i className="fa fa-search" aria-hidden="true"  onClick={ x =>  searchfull(fulltextsearch)}></i>
                                    </InputGroupText>
                                </InputGroup>
                              </FormGroup>
                              </Col>
                        </Row>
                        <Row>
                          <Col>
                          <TenantList tenantslist={tenantslist} pageNumber={pageNumber} limit={limit} setPageNumber={setPageNumber} setLimit={setLimit} nextpage={nextpage} previouspage={previouspage} total={total}  />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    </Col>
                </Row>
                </div>
                : 
                <div className="content">
                <Row>
                  <Col md="4">
                    <Card className="card-user">
                    
                      <CardBody>
                       
                        <div >
                            <center>
                            {showLogoProcessing ? <Spinner /> : 
                            <img
                              alt="..."
                              width={"200px"}
                              src={src}
                              style={{ cursor : "pointer"}} 
                              onClick={e => {
                                handleClick(e)
                              }}
                         />}
                          <h5 className="title">{tname.en} Tenant</h5>
                          <p className="description">{tenant.managerid}</p></center>
                        </div>
                            <center>
                                {tenant.addressIsVerified && tenant.cellIsVerified && 
                                <Badge className="shadow" style={{color :"black"}}>
                                &#9733; Verified
                                </Badge>
                                }
                              </center>
                        <p className="description text-center">
                                
                          If Landline, Address having <br />
                          checkboxes are checked <br />
                                "
                        </p>
                        <CardFooter>
                            <center>
                            <h6>Allowed Catagories</h6>
                            </center>
                            <Row style={{color : "gray"}}>
                            <Col>
                            <FormGroup>
                            <Input
                                            addon
                                            aria-label="Checkbox for following text input"
                                            type="checkbox"
                                            checked = {allowedCategories.cars}
                                            onChange={() => {}}
                                           onClick={ x => setAllowedCategories({...allowedCategories, cars : !allowedCategories.cars})}
                                        />{' '}
                              <i className="fa fa-car" aria-hidden="true">{' '}Car</i>
                              </FormGroup>
                            </Col>
                            <Col>
                            <FormGroup>
                                <Input
                                            addon
                                            aria-label="Checkbox for following text input"
                                            type="checkbox"
                                            checked = {allowedCategories.machines}
                                            onChange={() => {}}
                                            onClick={ x => setAllowedCategories({...allowedCategories, machines : !allowedCategories.machines})}
                                        />{' '}
                              <i className="fa fa-bath" aria-hidden="true">{' '}Machine</i>
                              
                              </FormGroup>
                            </Col>
                            <Col>
                            <FormGroup>
                                
                                <Input
                                            addon
                                            aria-label="Checkbox for following text input"
                                            type="checkbox"
                                            checked = {allowedCategories.yacht}
                                            onChange={() => {}}
                                            onClick={ x => setAllowedCategories({...allowedCategories, yacht : !allowedCategories.yacht})}
                                        />
                                <i className="fa fa-ship" aria-hidden="true">{' '}Yacht</i>                                
                              </FormGroup>
                            </Col>
                            </Row>
                            <Row>
                                <Col>
                            <center>
                              <hr />
                            <FormGroup>
                                <h6>Rating</h6>
                                <Rating
                                   onClick={f => {
                                    setTenant({...tenant, rating : f})
                                }}
                                initialValue={tenant.rating}
                                size = "20"
                                allowFraction	
                                 />
                                 <br />
                                {/** <p style={{marginTop : 15}}>.5 denomination</p> */}
                              </FormGroup>
                              </center>
                              </Col>
                            </Row>
                        </CardFooter>
                      </CardBody>
                    
                    </Card>
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Listing Permissions</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <ul className="list-unstyled team-members">
                          <li>
                            <Row>
                              <Col md="2" xs="2">
                                      <i className="fa fa-list-alt" style={{fontSize : 30, marginTop : 5}} aria-hidden="true"></i>
                              </Col>
                              <Col md="7" xs="7">
                                Listings Allowed<br />
                                <span className="text-muted">
                                <small>
                                    {
                                      editP.listing &&  <Input
                                      maxLength={3}    
                                      type="text"
                                          value = {allowed.listing}
                                          onChange={x => {
                                            if(numtest.test(x.target.value)){
                                              setAllowed({...allowed, listing : Number(x.target.value)})
                                            }
                                            else{
                                              setAllowed({...allowed, listing : 0})
                                            }
                                          }}
                                      />
                                    }
                                    {!editP.listing && allowed.listing}
                                  
                                  </small>
                                </span>
                              </Col>
                              <Col className="text-right" md="3" xs="3">
                                <Button
                                  className="btn-round btn-icon"
                                  color="success"
                                  outline
                                  size="sm"
                                >
                                  <i className="fa fa-pencil"
                                  onClick={x => setEditP({featured : false, listing : !editP.listing, premium : false})}
                                   />
                                </Button>
                              </Col>
                            </Row>
                          </li>
                          <hr />
                          <li>
                            <Row>
                              <Col md="2" xs="2">
                                <i className="fa fa-th-list" style={{fontSize : 30, marginTop : 5}} aria-hidden="true"></i>
                              </Col>
                              <Col md="7" xs="7">
                                Allowed Premium <br />
                                <span className="text-success">
                                  <small>
                                    {
                                      editP.premium &&  <Input
                                          type="text"
                                          maxLength={3}
                                          value = {allowed.premium}
                                          onChange={x => {
                                            if(Number(allowed.listing) < Number(x.target.value) + Number(allowed.featured) ){
                                            return
                                            }
                                            if(numdtest.test(x.target.value)){
                                              let val = Number(x.target.value) + Number(allowed.featured)
                                              if(val <= allowed.listing){
                                                setAllowed({...allowed, premium : Number(x.target.value)})
                                              }else{
                                                setAllowed({...allowed, premium : 0})  
                                              }
                                              
                                            }else{
                                              setAllowed({...allowed, premium : 0})
                                            }
                                            
                                          }}
                                      />
                                    }
                                    {!editP.premium && allowed.premium}
                                  
                                  </small>
                                </span>
                              </Col>
                              <Col className="text-right" md="3" xs="3">
                                <Button
                                  className="btn-round btn-icon"
                                  color="success"
                                  outline
                                  size="sm"
                                  onClick={x => setEditP({featured : false, listing : false, premium : !editP.premium})}
                                >
                                  <i className="fa fa-pencil" />
                                </Button>
                              </Col>
                            </Row>
                          </li>
                          < hr />
                          <li>
                            <Row>
                              <Col md="2" xs="2">
                                    <i className="fa fa-list-ol" style={{fontSize : 30, marginTop : 5}} aria-hidden="true"></i>
                              </Col>
                              <Col className="col-ms-7" xs="7">
                                Allowed Featured <br />
                                <span className="text-danger">
                                <small>
                                    {
                                      editP.featured &&  <Input
                                          type="text"
                                          maxLength={3}
                                          value = {allowed.featured}
                                          onChange={x => {
                                            if(Number(allowed.listing) < Number(allowed.premium) + Number(x.target.value) ){
                                              return 
                                            }
                                            if(numdtest.test(x.target.value)){
                                              let val = Number(allowed.premium) + Number(x.target.value)
                                              if(val <= allowed.listing){
                                                setAllowed({...allowed, featured : Number(x.target.value)})
                                              }else{
                                                setAllowed({...allowed, featured : 0})  
                                              }
                                              
                                            }else{
                                              setAllowed({...allowed, featured : 0})
                                            }
                                            
                                          }}
                                   
                                      />
                                    }
                                    {!editP.featured && allowed.featured}
                                  
                                  </small>
                                </span>
                              </Col>
                              <Col className="text-right" md="3" xs="3">
                                <Button
                                  className="btn-round btn-icon"
                                  color="success"
                                  outline
                                  size="sm"
                                >
                                  <i className="fa fa-pencil"   onClick={x => setEditP({premium : false, listing : false, featured : !editP.featured})} />
                                </Button>
                              </Col>
                            </Row>
                          </li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="8">
                    <Card>
                      <CardHeader>
                        <h5 className="title">Tenant Profile  {tenant.tuid !== "" ? `TUID : ${tenant.tuid}` : ""} <i className="fa fa-floppy-o" onClick={x => { tenant.tuid !== "" ? cinputConfirmAlert("u") : cinputConfirmAlert("c") }} style={{float : "right", cursor : "pointer"}} aria-hidden="true"></i> <i className="fa fa-undo" aria-hidden="true" style={{float : "right", cursor : "pointer", paddingRight : 35}} onClick={x => {setShowlist(!showlist); setUpdateMode(false); clearvalues()}}></i></h5>
                        
                      </CardHeader>
                      <CardBody>
                        <Form > 
                          <Row>
                            <Col className="pr-1" md="6">
                              <FormGroup>
                                <label>Company <span style={{color :"red"}}>*</span></label>
                                <InputGroup>
                                    {/**     disabled = {updateMode}  Change requested by Shahab in May 2024  */}
                                    <Input
                                    
                                        placeholder="Company"
                                        type="text"
                                        value = {tname.en}
                                        onChange={x => {
                                          setTname({en : x.target.value, fr : tname.fr, ar : tname.ar})
                                        }}
                                    />
                                    <InputGroupText>
                                    <i className="fa fa-globe" aria-hidden="true"></i>
                                    </InputGroupText>
                                </InputGroup>

                              
                              </FormGroup>
                            </Col>
                          {/**   <Col className="pr-1" md="4">
                              <FormGroup>
                                <label>..</label>
                                <InputGroup>
                                <Input
                                        placeholder="Company"
                                        type="text"
                                        maxLength={25}
                                        value = {tname.fr}
                                        onChange={x => {
                                          setTname({en : tname.en, fr : alphaspace.test(x.target.value) ? x.target.value: "" , ar : tname.ar})
                                        }}
                                    />
                                    <InputGroupText>
                                    Fr
                                    </InputGroupText>
                                </InputGroup>

                              
                              </FormGroup>
                            </Col> */}
                            <Col className="pr-1" md="6">
                              <FormGroup>
                                <label>..</label>
                                <InputGroup>
                                    
                                    <Input
                                       maxLength={25}
                                        placeholder="Company"
                                        type="text"
                                        value = {tname.ar}
                                        onChange={x => {
                                          setTname({en : tname.en, fr : tname.fr, ar : x.target.value})
                                        }}
                                    />
                                    <InputGroupText>
                                    Ar
                                    </InputGroupText>
                                </InputGroup>

                              
                              </FormGroup>
                            </Col>
                            </Row>
                            <Row> 
                            <Col className="pr-1" md="6">
                              <FormGroup>
                              <label>Manager ID<span style={{color :"red"}}>*</span></label>
                                <InputGroup>
                                    <Input
                                       maxLength={35}
                                        placeholder="Manager ID"
                                        type="text"
                                        value = {tenant.managerid}
                                        onChange={x => {
                                          setTenant({...tenant, managerid : x.target.value})
                                        }}
                                        
                                    />
                                    <InputGroupText>
                                    <i className="fa fa-key" aria-hidden="true"></i>
                                    </InputGroupText>
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="6">
                              <FormGroup>
                                <label htmlFor="exampleInputEmail1">
                                  Enqury Email
                                </label>
                                <Input placeholder="Email" type="email" 
                                value={tenant.enqEmail}
                                onChange={x => {
                                  setTenant({...tenant, enqEmail : x.target.value})
                                }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="pr-1" md="6">
                              <FormGroup>
                                <label>Manager Name <span style={{color :"red"}}>*</span></label>
                                <Input
                                 maxLength={35}
                                  placeholder="Portal Manager (B.R)"
                                  type="text"
                                  value = {tenant.mngName}
                                  onChange={x => {
                                    setTenant({...tenant, mngName : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="6">
                              <FormGroup>
                                <label>Manager's Cell Number <span style={{color :"red"}}>*</span></label>
                                <Input
                                  maxLength={35}
                                  placeholder="Manager's Cell number"
                                  type="text"
                                  value = {tenant.cellNumber}
                                  onChange={x => {
                                    setTenant({...tenant, cellNumber : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="pr-1" md="4">
                              <FormGroup>
                                <label>Land Line</label>
                                <InputGroup>
                                    <InputGroupText>
                                    <Input
                                            addon
                                            maxLength={35}
                                            aria-label="Checkbox for following text input"
                                            type="checkbox"
                                            checked = {tenant.cellIsVerified}
                                            onChange={() => {}}
                                            onClick={ x => setTenant({...tenant, cellIsVerified : !tenant.cellIsVerified})}
                                        />
                                    </InputGroupText>
                                    <Input
                               
                                  placeholder="Enquriy Number"
                                  type="text"
                                  value={tenant.landLine}
                                  onChange={x => {
                                    setTenant({...tenant, landLine : x.target.value})
                                  }}
                                />
                                </InputGroup>
                              
                              </FormGroup>
                            </Col>
                            <Col className="px-1" md="4">
                              <FormGroup>
                                <label>Whatsapp Number</label>
                                <Input
                                maxLength={35}
                                  placeholder="Company Whatsapp Number"
                                  type="text"
                                  value={tenant.waNumber}
                                  onChange={x => {
                                    setTenant({...tenant, waNumber : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="4">
                              <FormGroup>
                                <label>Cell Number <span style={{color :"red"}}>*</span></label>
                                <Input placeholder="Will be used by Admin to contact Tenant" type="text" 
                                   value = {tenant.cellNumberc}
                                   maxLength={35}
                                   onChange={x => {
                                    setTenant({...tenant, cellNumberc : x.target.value})
                                  }}
                                   />
                              </FormGroup>
                            </Col>
                          </Row>
                   
                          <Row>
                          <Col className="pr-1" md="4">
                              <FormGroup>
                                <label><i className="fa fa-youtube" aria-hidden="true"></i>{' '} Yourube </label>
                                <Input
                                
                                  placeholder="Youtube"
                                  type="text"
                                  maxLength={50}
                                  value={tenant.liProfile}
                                  onChange={x => {
                                    setTenant({...tenant, liProfile : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="px-1" md="4">
                              <FormGroup>
                                <label><i className="fa fa-facebook" aria-hidden="true"></i> { ' '}Facebook </label>
                                <Input
                                 
                                  placeholder="Facebook Profile"
                                  type="text"
                                  maxLength={50}
                                  value={tenant.fbProfile}
                                  onChange={x => {
                                    setTenant({...tenant, fbProfile : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="4">
                              <FormGroup>
                                <label><i className="fa fa-instagram" aria-hidden="true"></i> {' '} Instagram</label>
                                <Input placeholder="Instagram" 
                                value = {tenant.insProfile}
                                maxLength={50}
                                onChange={x => {
                                  setTenant({...tenant, insProfile : x.target.value})
                                }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <FormGroup>
                              <label>Street Address</label>
                                <InputGroup>
                                    <InputGroupText>
                                    <Input
                                            maxLength={35}
                                            addon
                                            aria-label="Checkbox for following text input"
                                            type="checkbox"
                                            checked = {tenant.addressIsVerified}
                                            onChange={() => {}}
                                            onClick={ x => setTenant({...tenant, addressIsVerified : !tenant.addressIsVerified})}
                                        />
                                    </InputGroupText>
                                    <Input
                                      placeholder="Street Address"
                                      type="text"
                                      value={tenant.stAddr}
                                              
                                      onChange={x => {
                                        setTenant({...tenant, stAddr : x.target.value})
                                      }}
                                    />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="pr-1" md="4">
                              <FormGroup>
                                <label>City</label>
                                <Select options={storarea} styles={customStyles} 
                                   value={{label : city.en + ' ' + city.ar, value : city.cityCode}} 
                                   onChange={e=> {setCity({cityCode: e.value, en: e.label, fr: e.labelfr, ar: e.labelar});
                                          setArealist(e.areas.map(t => {
                                            return {
                                              ...t, value : t.areaCode, label: t.en, labelfr: t.fr, labelar : t.ar
                                            }
                                          }));  
                                          setArea({areaCode : "", en : "", fr : "", ar : ""})      
                                        }}
                                   />
                              </FormGroup>
                            </Col>
                            <Col className="px-1" md="4">
                              <FormGroup>
                                <label>Area</label>
                                <Select options={arealist} styles={customStyles} 
                                   value={{label : area.en + ' '+  area.ar , value : area.cityCode}} 
                                   onChange={e=> {setArea({areaCode: e.value, en: e.label, fr: e.fr, ar: e.ar}) }}
                                   />
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="4">
                              <FormGroup>
                                <label>Postal Code</label>
                                <Input placeholder="Postal Code" 
                                type="text"
                                value = {tenant.postal}
                                onChange={x => {
                                  setTenant({...tenant, postal : x.target.value})
                                }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <Row>
                                <Col>
                                <FormGroup>
                                <label>About Tenant</label>
                                <Input
                                maxLength={300}
                                  className="textarea"
                                  type="textarea"
                                  cols="80"
                                  rows="4"
                                  value={tenant.aboutWords}
                                  onChange={x => {
                                    setTenant({...tenant, aboutWords : x.target.value})
                                  }}
                                 
                                />
                              </FormGroup>
                              </Col>
                                <Col>
                                <FormGroup>
                                <label>حول المستأجر</label>
                                <Input
                                maxLength={300}
                                  className="textarea"
                                  type="textarea"
                                  cols="80"
                                  rows="4"
                                  value={tenant.aboutWordsar}
                                  onChange={x => {
                                    setTenant({...tenant, aboutWordsar : x.target.value})
                                  }}
                                 
                                />
                              </FormGroup>
                              </Col>
                              </Row>
                              
                            </Col>
                          </Row>
                        </Form>
                      </CardBody>
                    </Card>
                    {/** 
                    <Card>
                      <CardHeader>
                        <h5 className="title">Bank Information</h5>
                        <i style={{color : "lightgray"}}>*Admins may save information here about Tenant's bank information if required.</i>
                      </CardHeader>
                      <CardBody>
                          <Row>
                            <Col className="pr-1" md="4">
                              <FormGroup>
                                <label>Bank Name</label>
                                <Input
                                  maxLength={50}     
                                  placeholder="Company Bank"
                                  type="text"
                                  value= {bank.bankName}
                                  onChange={x => {
                                    setBank({...bank,  bankName : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="px-1" md="4">
                              <FormGroup>
                                <label>SWIFT Code</label>
                                <Input
                               maxLength={50}     
                                  placeholder="SWIFT"
                                  type="text"
                                  value= {bank.swiftCode}
                                  onChange={x => {
                                    setBank({...bank,  swiftCode : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="4">
                              <FormGroup>
                                <label>Routing Code</label>
                                <Input placeholder="Routing Code" 
                                maxLength={50}     
                                 value= {bank.routingCode}
                                 onChange={x => {
                                  setBank({...bank,  routingCode : x.target.value})
                                }}/>

                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="pr-1" md="6">
                              <FormGroup>
                                <label>IBAN #</label>
                                <Input
                             maxLength={50}     
                                  placeholder="IBAN Number"
                                  type="text"
                                  value= {bank.iban}
                                  onChange={x => {
                                    setBank({...bank,  iban : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col className="pl-1" md="6">
                              <FormGroup>
                                <label>Account #</label>
                                <Input
                               maxLength={50}     
                                  placeholder="Account Number"
                                  type="text"
                                  value= {bank.account}
                                  onChange={x => {
                                    setBank({...bank,  account : x.target.value})
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                      </CardBody>
                    </Card>
                  */}
                  </Col>
                </Row>
              </div>
      }
      
      
    </>
  );
}

export default Tenant;
